export default __webpack_public_path__ + "20b5d8a288625e7db6493a2590b1641b.png";